import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';                  // ✅ Add this
import { saveAs } from 'file-saver';           // ✅ Add this

const FreelancerEmailVerificationPage = () => {
  const [emailVerification, setEmailVerification] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
  const columns = ['Email', 'Token', 'Verified', 'Verified At'];

  useEffect(() => {
    const fetchEmailVerification = async () => {
      const token = localStorage.getItem('employeeToken');
      if (!token) {
        window.location.href = "/employee-login";
        return;
      }

      try {
        const response = await axios.get(`${apiBaseURL}/api/freelancer-email-verification`);
        setEmailVerification(response.data);
      } catch (err) {
        setError('Failed to fetch email verification info.');
      } finally {
        setLoading(false);
      }
    };

    fetchEmailVerification();
  }, [apiBaseURL]);

  if (loading) return <div>Loading email verification info...</div>;
  if (error) return <div>{error}</div>;

  const data = emailVerification
    .map(item => ({
      email: item.email,
      token: item.token,
      verified: item.verified ? 'Yes' : 'No',
      verified_at: item.verified_at ? new Date(item.verified_at).toLocaleString() : 'Not Verified',
    }))
    .sort((a, b) => {
      if (!a.verified_at) return 1;
      if (!b.verified_at) return -1;
      return new Date(b.verified_at) - new Date(a.verified_at);
    });

  const total = data.length;
  const verifiedCount = data.filter(item => item.verified === 'Yes').length;
  const notVerifiedCount = total - verifiedCount;

  // ✅ Excel Download Function
  const downloadExcel = () => {
    const worksheetData = [
      ['OrderMinds Freelancing Solutions LLP'],
      ['Downloaded At:', new Date().toLocaleString()],
      [],
      ['Freelancer Email Verification'],
      [],
      ['Email', 'Token', 'Verified', 'Verified At'],
      ...data.map(item => [item.email, item.token, item.verified, item.verified_at])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Freelancer Email Verification');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'freelancer_email_verification.xlsx');
  };

  // ✅ Download Button component
  const DownloadButton = () => (
    <button
      onClick={downloadExcel}
      className="ml-auto px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
    >
      Download Excel
    </button>
  );

  const Table = ({ columns, data }) => (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
        <thead>
          <tr className="bg-gray-200">
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-2 text-left">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-2 text-center text-gray-500">No data available</td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-b">
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className="px-4 py-2">
                    {row[col.toLowerCase().replace(/ /g, '_')]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="flex-1 p-6 bg-gray-100 ml-64">
      <div className="flex items-center mb-4">
        <h2 className="text-2xl font-semibold">Freelancer Email Verification</h2>
        <DownloadButton /> {/* ✅ Button here */}
      </div>

      <div className="mb-4 p-4 bg-white rounded shadow-md flex gap-6">
        <div><strong>Total Emails:</strong> {total}</div>
        <div><strong>Verified:</strong> {verifiedCount}</div>
        <div><strong>Not Verified:</strong> {notVerifiedCount}</div>
      </div>

      <Table columns={columns} data={data} />
    </div>
  );
};

export default FreelancerEmailVerificationPage;
